import { render } from "./AddPatientNavigationSettingOverlay.vue?vue&type=template&id=525163b3&lang=pug"
import script from "./AddPatientNavigationSettingOverlay.vue?vue&type=script&lang=js"
export * from "./AddPatientNavigationSettingOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__